<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="60%"
    top="10vh"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <span slot="title" class="title-container">
      <span class="title-text">{{factoryName + $t('factoryLabelPrint.templateContentEditing')}}</span>
      <img
        src="@/assets/close.png"
        class="close-image"
        @click="close"
      />
    </span>
    <el-form class="el-form" :model="form" ref="refForm" :rules="rules" label-width="120px">
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.customerName') + ':'" prop="customerName">
            {{form.customerName}}
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.productNameOrSpecification') + ':'" prop="partNo">
            <el-input
              v-model.trim="form.partNo"
              name="partNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.materialNo')" prop="materialNo">
            <el-input
              v-model.trim="form.materialNo"
              name="materialNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.orderNo')" prop="orderNo">
            <el-input
              v-model.trim="form.orderNo"
              name="orderNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('common.count')" prop="count">
            <el-input
              v-model.trim.number="form.count"
              name="count"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.weight') + ':'" prop="weight">
            <el-input
              v-model.trim="form.weight"
              name="weight"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.deliveryDate') + ':'" prop="deliveryDate">
            <el-date-picker
              v-model="form.deliveryDate"
              type="date"
              size="small"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.qiangLiBatchNo') + ':'" prop="batchNo">
            <el-input
              v-model.trim="form.batchNo"
              name="batchNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('common.stylePreview') + ':'" style="margin-bottom: 0">
      </el-form-item>
      <el-form-item>
        <el-col :span="15">
          <iframe
            id="labelIFrameQiangLiJuCaiDialog"
            scrolling="auto"
            width="520"
            height="260"
            frameborder="0"
            style="background: #E9E9E9;"
          ></iframe>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button size="small" @click="close">{{$t('common.cancel')}}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submitForm">
            {{$t('common.print')}}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
  import {
    validateCount,
    validateWeight,
  } from '@/utils/validate';
  import {
    initQiangLiJuCaiLabelFrame,
    printFactoryLabel,
  } from '@/utils/factory-label';

  export default {
    name: "QiangLiJuCaiLabelDialog",
    props: {
      factoryName: {
        type: String,
        default: '',
      },
      visible: {
        type: Boolean,
        default: false,
      },
    },
    data() {

      return {
        form: {
          customerName: '厦门强力巨彩光电科技有限公司',
          partNo: undefined,
          materialNo: undefined,
          orderNo: undefined,
          count: undefined,
          weight: undefined,
          deliveryDate: undefined,
          batchNo: undefined,
        },
        rules: {
          customerName: [{
            required: true,
            trigger: 'blur',
            message: this.$t('validate.customerNameCanNotBeEmpty')
          }],
          partNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.productNameOrSpecificationCanNotBeEmpty')
          }],
          materialNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.materialNoCanNotBeEmpty')
          }],
          orderNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.orderNoCanNotBeEmpty')
          }],
          count: [{
            required: true,
            trigger: 'blur',
            validator: validateCount
          }],
          weight: [{
            required: true,
            trigger: 'blur',
            validator: validateWeight
          }],
          deliveryDate: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.deliveryDateCanNotBeEmpty')
          }],
          batchNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.qiangLiBatchNoCanNotBeEmpty')
          }],
        }
      };
    },
    watch: {
      visible(newValue) {
        if (newValue) {
          setTimeout(() => {
            this.initQiangLiJuCaiLabelFrame();
          });
        }
      }
    },
    methods: {
      handleDialogClose() {
        this.close();
      },
      close() {
        this.$emit('update:visible', false);
        this.$emit('close');
        if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
          this.$refs.refForm.clearValidate();
        }
      },
      submitForm() {
        this.$refs.refForm.validate(async (valid) => {
          if (valid) {
            this.printQiangLiJuCaiLabelFrame();
          }
        });
      },
      initQiangLiJuCaiLabelFrame() {
        let iframe = document.getElementById('labelIFrameQiangLiJuCaiDialog');
        iframe = initQiangLiJuCaiLabelFrame({
          iframe,
          partNo: 'LS9929STR',
          materialNo: '10102243',
          orderNo: '0000082253',
          count: 25000,
          weight: 12.65,
          deliveryDate: '2018-05-12',
          batchNo: 'IC561805001'
        });
        iframe.contentWindow.document.close();
      },
      printQiangLiJuCaiLabelFrame() {
        const {
          partNo,
          materialNo,
          orderNo,
          count,
          weight,
          deliveryDate,
          batchNo,
        } = this.form;
        let iframe = document.getElementById('labelIFrameQiangLiJuCaiDialog');
        iframe = initQiangLiJuCaiLabelFrame({
          iframe,
          partNo,
          materialNo,
          orderNo,
          count,
          weight,
          deliveryDate,
          batchNo,
        });
        iframe.contentWindow.document.close();
        printFactoryLabel(iframe);
      },
    }
  }
</script>

<style scoped>
  .title-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: space-between;
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
    padding: 10px 15px;
    align-items: center;
  }

  .title-text {
    color: #404040;
    font-size: 16px;
  }

  .el-form {
    margin: 0 30px;
  }

  .close-image {
    width: 22px;
    height: 22px;
    cursor: pointer;
    padding: 0 10px;
  }
</style>
<style>
  .edit-detail-dialog .el-dialog__header {
    padding: 0;
  }
</style>
